import { Input } from "@/components/UI";
import { Button } from "@/components/UI/Buttons/Button";
import { useEffect, useState } from "react";
import { adminControlClass, adminLabelClass } from "../../../Shared/adminUi";

interface PromptFormProps<T, P> {
  selectedType: T;
  onSubmit: (name: string, content: string) => void;
  onUpdate: (prompt: P) => void;
  onBack: () => void;
  editingPrompt?: P;
  onCancelEdit: () => void;
  title?: string;
}

function PromptForm<
  T extends { id: number; name: string },
  P extends { id: number; name: string; content: string },
>({
  selectedType,
  onSubmit,
  onUpdate,
  onBack,
  editingPrompt,
  onCancelEdit,
  title,
}: PromptFormProps<T, P>) {
  const [name, setName] = useState<string>("");
  const [content, setContent] = useState<string>("");

  useEffect(() => {
    if (editingPrompt) {
      setName(editingPrompt.name);
      setContent(editingPrompt.content);
    } else {
      setName("");
      setContent("");
    }
  }, [editingPrompt]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    e.stopPropagation();

    if (!name.trim() || !content.trim()) return;

    if (editingPrompt) {
      onUpdate({
        ...editingPrompt,
        name: name.trim(),
        content: content.trim(),
      });
    } else {
      onSubmit(name.trim(), content.trim());
      setName("");
      setContent("");
    }
  };

  return (
    <form className="flex flex-col" onSubmit={handleSubmit}>
      <h4 className="text-ink mb-4 line-clamp-3 text-center font-semibold">
        {editingPrompt
          ? `Redaguoti prompt - ${selectedType.name}`
          : title || `Pridėti naują prompt - ${selectedType.name}`}
      </h4>
      <Input
        label="Pavadinimas"
        type="text"
        className="mb-4"
        value={name}
        onChange={(event) => setName(event.target.value)}
        required
      />
      <div className="mb-4">
        <label className={adminLabelClass}>Turinys</label>
        <textarea
          className={adminControlClass}
          rows={4}
          value={content}
          onChange={(event) => setContent(event.target.value)}
          required
        />
      </div>

      <div className="flex flex-col gap-2">
        <Button type="submit" className="mt-4" size="sm">
          {editingPrompt ? "Išsaugoti pakeitimus" : "Išsaugoti"}
        </Button>

        {editingPrompt ? (
          <Button
            variant="secondary"
            size="sm"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onCancelEdit();
            }}
          >
            Atšaukti redagavimą
          </Button>
        ) : (
          <Button
            variant="secondary"
            size="sm"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onBack();
            }}
          >
            Grįžti į sąrašą
          </Button>
        )}
      </div>
    </form>
  );
}

export default PromptForm;
